import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../../../firebase";

export default function ApprovedUsersViewModal() {
  const navigate = useNavigate();
  const [ApprovedStudents, setApprovedStudents] = useState([]);
  const [ApprovedParents, setApprovedParents] = useState([]);
  const [ApprovedTeachers, setApprovedTeachers] = useState([]);
  const [Refresh, setRefresh] = useState(true);
  const [UserId, setUserId] = useState("");
  const [IsLoading, setIsLoading] = useState(true);
  let schoolId = localStorage.getItem("schoolId");
  schoolId = JSON.parse(schoolId);

  // Action Confirmation Start
  const [OpenDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = (id) => {
    setUserId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = async (del) => {
    setOpenDialog(false);
    if (del === true) {
      RejectUser(UserId);
      setOpenDialog(false);
      setRefresh(!Refresh);
    }
  };
  // Action Confirmation End

  useEffect(() => {
    const fetchData = () => {
      if (schoolId) {
        GetApprovedTeachers();
        GetApprovedStudents();
        GetApprovedParents();
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [Refresh]);
  const GetApprovedStudents = async () => {
    let UsersRef = collection(db, "Users");
    let tempArray = [];

    const q = query(
      UsersRef,
      where("UserType", "==", "student"),
      where("IsVerified", "==", 1),
      where("SchoolID", "==", schoolId)
    );

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      tempArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setApprovedStudents([...tempArray]);
  };
  const GetApprovedParents = async () => {
    let UsersRef = collection(db, "Users");
    let tempArray = [];

    const q = query(
      UsersRef,
      where("UserType", "==", "parent"),
      where("IsVerified", "==", 1),
      where("SchoolID", "==", schoolId)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      tempArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setApprovedParents([...tempArray]);
  };
  const GetApprovedTeachers = async () => {
    let UsersRef = collection(db, "Users");
    let tempArray = [];

    const q = query(
      UsersRef,
      where("UserType", "==", "teacher"),
      where("IsVerified", "==", 1),
      where("SchoolID", "==", schoolId)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      tempArray.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    setApprovedTeachers([...tempArray]);
  };

  const ApproveUser = (uid) => {
    let DocRef = doc(db, "Users", uid);
    setDoc(
      DocRef,
      {
        IsVerified: 1,
      },
      { merge: true }
    );
    setRefresh(!Refresh);
  };

  const RejectUser = (uid) => {
    let DocRef = doc(db, "Users", uid);
    setDoc(
      DocRef,
      {
        IsVerified: 2,
      },
      { merge: true }
    );
    setRefresh(!Refresh);
  };

  return {
    ApprovedStudents,
    ApprovedParents,
    ApprovedTeachers,
    ApproveUser,
    RejectUser,
    OpenDialog,
    handleOpenDialog,
    handleCloseDialog,
    IsLoading,
    navigate,
  };
}
